import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconUsbC: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconUsbC"><Path fillRule="evenodd" clipRule="evenodd" d="M0 12C0 8.68629 2.68629 6 6 6H18C21.3137 6 24 8.68629 24 12C24 15.3137 21.3137 18 18 18H6C2.68629 18 0 15.3137 0 12ZM5 11.25V12.75H19V11.25H5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconUsbC;
